<template>
  <transition name="slide-fade" @after-leave="handleAfterLeave">
    <template v-if="visible">
      <div :class="tipClass" :style="positionStyle">
        <i :class="iconClass"></i>
        <span>{{ message }}</span>
      </div>
    </template>
  </transition>
</template>
<script>
  const TIP = {
    success: 'fdd-tips-success', //绿色提示框（成功）
    warning: 'fdd-tips-caveat', //黄色色提示框（警告）
    error: 'fdd-tips-error' //默认红色提示框（错误）
  }
  const ICON = {
    success: 'use-icon_radio',
    warning: 'use-info',
    error: 'use-close'
  }
  /**
   * 消息提醒框
   */
  export default {
    name: 'Message',
    data() {
      return {
        timer: null,
        message: '',
        type: '',
        duration: 3000,
        onClose: null,
        visible: false,
        verticalOffset: 0
      }
    },
    computed: {
      tipClass() {
        return TIP[this.type] || 'fdd-tips-success'
      },
      iconClass() {
        return ICON[this.type] || 'use-icon_radio'
      },
      positionStyle() {
        return {
          top: `${this.verticalOffset}px`
        }
      }
    },
    mounted() {
      this.startTimer()
    },
    methods: {
      clearTimer() {
        if (this.timer) {
          clearTimeout(this.timer)
        }
      },
      startTimer() {
        if (this.duration > 0) {
          this.timer = setTimeout(() => {
            this.close()
            this.clearTimer()
          }, this.duration)
        }
      },
      handleAfterLeave() {
        if (this.$el) this.$el.parentNode.removeChild(this.$el)
        this.$destroy(true)
      },
      close() {
        this.visible = false
        this.onClose && this.onClose(this)
      }
    }
  }
</script>
<style lang="less" scoped>
  .slide-fade {
    &-enter,
    &-leave-to {
      margin-top: -46px;
      opacity: 0;
    }
  }
</style>
